import React, { useEffect, useState } from "react";
import "./Apply.css";
import { useParams } from "react-router-dom";
import { doc, getDoc, collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

function Apply() {
  const { id } = useParams();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    portfolio: "",
    message: "",
  });
  const [resumeFile, setResumeFile] = useState(null);
  const [fileError, setFileError] = useState("");

  // Fetch Job
  useEffect(() => {
    const fetchJob = async () => {
      try {
        const docRef = doc(db, "jobs", id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) setJob(docSnap.data());
      } catch (err) {
        console.error("Job fetch error:", err);
      }
    };
    fetchJob();
  }, [id]);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];

    if (!allowedTypes.includes(file.type)) return setFileError("Only PDF/DOC/DOCX allowed");
    if (file.size > 5 * 1024 * 1024) return setFileError("File must be < 5MB");

    setFileError("");
    setResumeFile(file);
  };

  // Upload to Cloudinary
  const uploadToCloudinary = async (file) => {
    const formDataCloud = new FormData();
    formDataCloud.append("file", file);
    formDataCloud.append("upload_preset", "resume"); // <-- Your preset name
    formDataCloud.append("folder", "resume"); // <-- Upload inside resume folder
    const response = await fetch("https://api.cloudinary.com/v1_1/dcucpz86i/auto/upload", {
      method: "POST",
      body: formDataCloud,
    });
    const data = await response.json();
    return data.secure_url;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!resumeFile) return alert("Please upload your resume");

    try {
      setLoading(true);

      // Upload resume to Cloudinary
      const resumeURL = await uploadToCloudinary(resumeFile);

      // Save application data to Firestore
      await addDoc(collection(db, "applications"), {
        jobId: id,
        jobTitle: job?.title || "",
        ...formData,
        resumeURL,
        status: "Pending",
        createdAt: serverTimestamp(),
      });

      alert("Application Submitted Successfully 🚀");

      setFormData({ name: "", email: "", phone: "", portfolio: "", message: "" });
      setResumeFile(null);
    } catch (err) {
      console.error("Submit error:", err);
      alert("Something went wrong!");
    }
    setLoading(false);
  };

  return (
    <div className="apply-page">
      {job && (
        <div className="job-preview">
          <h1>{job.title}</h1>
          <p>{job.description}</p>
        </div>
      )}

      <div className="form-container">
        <h2>Apply Now</h2>
        <form onSubmit={handleSubmit} className="apply-form">
          <input type="text" name="name" placeholder="Full Name" value={formData.name} onChange={handleChange} required />
          <input type="email" name="email" placeholder="Email Address" value={formData.email} onChange={handleChange} required />
          <input type="text" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} required />
          <input type="text" name="portfolio" placeholder="Portfolio / GitHub Link" value={formData.portfolio} onChange={handleChange} />
          <textarea name="message" placeholder="Why should we hire you?" rows="4" value={formData.message} onChange={handleChange} />

          <div className="resume-upload">
            <label>Upload Resume (PDF/DOC, Max 5MB)</label>
            <input type="file" name="resume" onChange={handleFileChange} required />
            {resumeFile && <p>Selected: {resumeFile.name}</p>}
            {fileError && <p className="error">{fileError}</p>}
          </div>

          <button type="submit" disabled={loading}>
            {loading ? "Submitting..." : "Submit Application"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Apply;